import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../ui/Modal';
import { errText } from './ftpViewHelpers';

/* ── New folder / rename modal ──────────────────────────────────────────── */

export function NameModal({ spec, onClose, onSubmit }) {
  const { t } = useTranslation();
  const isRename = spec.mode === 'rename';
  const isFile = spec.mode === 'newfile';
  const isArchive = spec.mode === 'archive';
  const isMove = spec.mode === 'move';
  const title = isRename
    ? t('ftp.rename')
    : isFile
      ? t('ftp.newFile')
      : isArchive
        ? t('ftp.compress')
        : isMove
          ? t('ftp.moveTo')
          : t('ftp.newFolder');
  const label = isRename
    ? t('ftp.newName')
    : isFile
      ? t('ftp.fileName')
      : isArchive
        ? t('ftp.archiveName')
        : isMove
          ? t('ftp.moveDestination')
          : t('ftp.folderName');
  const [value, setValue] = useState(
    isRename ? spec.entry.name : spec.defaultName || ''
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = value.trim();
    if (!name || saving) return;
    setSaving(true);
    setError(null);
    try {
      await onSubmit(name);
      onClose();
    } catch (err) {
      setError(errText(err));
      setSaving(false);
    }
  };

  return (
    <Modal isOpen onClose={onClose} title={title}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="modal-logo-label" style={{ display: 'block', marginBottom: '0.375rem' }}>
            {label}
          </label>
          <input
            type="text"
            className="modal-input"
            style={{ width: '100%' }}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoFocus
            spellCheck={false}
          />
        </div>
        {error && <div className="ftp-modal-error">{error}</div>}
        <div className="modal-footer-row">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors modern-button-secondary text-sm"
          >
            {t('common.cancel')}
          </button>
          <button
            type="submit"
            disabled={!value.trim() || saving}
            className="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors modern-button text-sm"
          >
            {isRename ? t('ftp.rename') : isMove ? t('ftp.move') : t('ftp.create')}
          </button>
        </div>
      </form>
    </Modal>
  );
}
